var exports = {
  "container": "x43cbe9c2--fde045--container",
  "text-block": "x43cbe9c2--fde045--text-block",
  "title": "x43cbe9c2--fde045--title",
  "description": "x43cbe9c2--fde045--description",
  "btn": "x43cbe9c2--fde045--btn",
  "phone": "x43cbe9c2--fde045--phone",
};

module.exports = exports;
